<script>
	export default {
		name: 'NotificationExecuter',
		methods: {
			//
		}
	}
</script>